import ReactGA from "react-ga4";

// ✅ Use your actual Measurement ID
const GA_MEASUREMENT_ID = "G-6WC263Z4E1";

export const initGA = () => {
  if (!window.GA_INITIALIZED) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    window.GA_INITIALIZED = true;
  }
};

export const trackPageView = (path) => {
    // console.log("Tracking pageview:", path); 
  ReactGA.send({ hitType: "pageview", page: path });
};
